import { render, staticRenderFns } from "./search-by-connections.vue?vue&type=template&id=54a13d58&"
import script from "./search-by-connections.vue?vue&type=script&lang=js&"
export * from "./search-by-connections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports